import {
  EventDetailsResponse,
  GetPerformanceAvailabilitiesResponse,
  GetPerformancesResponse,
  ReserveTicketsRequest,
  ReserveTicketsResponse,
} from '@grpc-clients/external/mercury/v1/entertainment/entertainment.pb';
import { Action } from '@ngrx/store';

export const GET_TICKET_EVENT_DETAILS = '[Entertainment Event Details] Get event details';
export const GET_TICKET_EVENT_DETAILS_SUCCESS = '[Entertainment Event Details] Get event details success';
export const GET_TICKET_EVENT_DETAILS_FAILURE = '[Entertainment Event Details] Get event details failure';
export const CLEAR_TICKET_EVENT_DETAILS = '[Entertainment Event Details] Clear event details';

export const GET_TICKET_EVENT_PERFORMANCES = '[Entertainment Event Performances] Get event performances';
export const GET_TICKET_EVENT_PERFORMANCES_SUCCESS =
  '[Entertainment Event Performances] Get event performances success';
export const GET_TICKET_EVENT_PERFORMANCES_FAILURE =
  '[Entertainment Event Performances] Get event performances failure';

export const GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY =
  '[Entertainment Event Performances Availability] Get event performances availability';
export const GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_SUCCESS =
  '[Entertainment Event Performances Availability] Get event performances availability success';
export const GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_FAILURE =
  '[Entertainment Event Performances Availability] Get event performances availability failure';
export const CLEAR_TICKET_EVENT_PERFORMANCES = '[Entertainment Event Performances] Clear event performances';

export const RESERVE_TICKETS = '[Entertainment Reserve Tickets] Reserve tickets';
export const RESERVE_TICKETS_SUCCESS = '[Entertainment Reserve Tickets] Reserve tickets success';
export const RESERVE_TICKETS_FAILURE = '[Entertainment Reserve Tickets] Reserve tickets failure';
export const DYNAMIC_SEAT_MAP_DIRTY = '[Entertainment Reserve Tickets] Dynamic seat map dirty';

export class GetTicketEventDetails implements Action {
  readonly type = GET_TICKET_EVENT_DETAILS;
  constructor(public eventId: number) {}
}
export class GetTicketEventDetailsSuccess implements Action {
  readonly type = GET_TICKET_EVENT_DETAILS_SUCCESS;
  constructor(public eventDetails: EventDetailsResponse) {}
}
export class GetTicketEventDetailsFailure implements Action {
  readonly type = GET_TICKET_EVENT_DETAILS_FAILURE;
}

export class ClearTicketEventDetails implements Action {
  public readonly type = CLEAR_TICKET_EVENT_DETAILS;
}

export class GetTicketEventPerformances implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES;
  constructor(public payload: { eventId: number; performanceId?: number; startDate?: string; endDate?: string }) {}
}
export class GetTicketEventPerformancesSuccess implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES_SUCCESS;
  constructor(public performances: GetPerformancesResponse) {}
}
export class GetTicketEventPerformancesFailure implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES_FAILURE;
}

export class GetTicketEventPerformanceAvailability implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY;
  constructor(public performanceIds: number[]) {}
}
export class GetTicketEventPerformanceAvailabilitySuccess implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_SUCCESS;
  constructor(public performancesAvailability: GetPerformanceAvailabilitiesResponse) {}
}
export class GetTicketEventPerformanceAvailabilityFailure implements Action {
  public readonly type = GET_TICKET_EVENT_PERFORMANCES_AVAILABILITY_FAILURE;
}
export class ClearTicketEventPerformances implements Action {
  public readonly type = CLEAR_TICKET_EVENT_PERFORMANCES;
}
export class ReserveTickets implements Action {
  public readonly type = RESERVE_TICKETS;
  constructor(public payload: ReserveTicketsRequest) {}
}
export class ReserveTicketsSuccess implements Action {
  public readonly type = RESERVE_TICKETS_SUCCESS;
  constructor(
    public reserveTickets: ReserveTicketsResponse,
    public paymentToken: string,
    public performanceId: number
  ) {}
}
export class ReserveTicketsFailure implements Action {
  public readonly type = RESERVE_TICKETS_FAILURE;
}

export class DynamicSeatMapDirty implements Action {
  public readonly type = DYNAMIC_SEAT_MAP_DIRTY;
  constructor(public dirty: boolean) {}
}

export type EntertainmentDetailsPageActions =
  | GetTicketEventDetails
  | GetTicketEventDetailsSuccess
  | GetTicketEventDetailsFailure
  | ClearTicketEventDetails
  | GetTicketEventPerformances
  | GetTicketEventPerformancesSuccess
  | GetTicketEventPerformancesFailure
  | GetTicketEventPerformanceAvailability
  | GetTicketEventPerformanceAvailabilitySuccess
  | GetTicketEventPerformanceAvailabilityFailure
  | ClearTicketEventPerformances
  | ReserveTickets
  | ReserveTicketsSuccess
  | ReserveTicketsFailure
  | DynamicSeatMapDirty;
